<template>
    <form-partition :title="text + '信息'" :model="value">
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="changeDate" :label="text + '时间'">
                    <DatePicker
                        type="datetime"
                        v-model="value.changeDate"
                        placeholder=""
                        format="yyyy-MM-dd"
                    />
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="changeReason" :label="text + '原因'">
                    <Select v-model="value.changeReason" transfer>
                        <Option
                            v-for="item in dict.changeReason.options.list"
                            :value="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </Option>
                    </Select>
                </FormItem>
            </Col>
        </Row>
    </form-partition>
</template>
<script>
import { Field } from 'ivux'

export default {
    name: 'ChangeInfo',

    mixins: [Field],

    props: {
        value: {
            type: Object,
            default: () => ({
                changeDate: '',
                changeReason: '',
            }),
        },
        text: {
            type: String,
            default: '换房',
        },
        type: {
            type: [Number, String],
            default: '',
        },
        populateType: {
            type: String,
            default: 'through',
        },
        justRead: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            dict: {
                changeReason: this.$dict.NULL,
            },
        }
    },
    watch: {},
    computed: {},
    created() {
        this.$dict.get(['change_reason']).then((group) => {
            Object.assign(this.dict, group)
        })
    },
    methods: {},
}
</script>
<style lang="less" scoped></style>
